import clsx from 'clsx'
import React, {FC} from 'react'
import {useSubmenu} from './SubmenuContext'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'

const Header: FC = () => {
    const submenuTypes = [
        {name: 'Administrativo', type: 'core'},
        {name: 'Financeiro', type: 'financial'},
        {name: 'Empresarial', type: 'business'},
        {name: 'Representantes', type: 'reps'},
        {name: 'PDVs', type: 'pdvs'},
    ]
    const {submenuType, setSubmenuType} = useSubmenu()

    return (
        <div
            className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
            id='kt_header_clinic_menu_toggle'
        >
            <div className='d-flex align-items-stretch flex-shrink-0'>
                <div className='btn-group'>
                    {submenuTypes.map((e) => (
                        <button
                            onClick={() => {
                                setSubmenuType(e.type)
                            }}
                            className={`btn btn-${
                                e.type === submenuType ? 'primary' : 'transparent'
                            } text-white btn-sm fs-6`}
                        >
                            {e.name}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}

export {Header}
